const Mock = require('mockjs');

const memberList = [
	{
		id: 1,
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/axjww-f14uh-001.jpg" alt=""><img width="100%" src="http://copyright.gzcc315.com/images/axjww-f14uh-002.jpg" alt="">',
	},
	{
		id: 2,
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/aj8f1-8jyjc-001.jpg" alt=""><img width="100%" src="http://copyright.gzcc315.com/images/aj8f1-8jyjc-002.jpg" alt="">',
	},
	{
		id: 3,
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/a90p9-1slb2-001.jpg" alt="">'
	},
	{
		id: 4,
		content: '<img width="100%" src="http://copyright.gzcc315.com/images/adn1j-6x2ql-001.jpg" alt=""><img width="100%" src="http://copyright.gzcc315.com/images/adn1j-6x2ql-002.jpg" alt=""><img width="100%" src="http://copyright.gzcc315.com/images/adn1j-6x2ql-003.jpg" alt="">'
	}
];

Mock.mock('http://copyright.gzcc315.com/member', 'get', options => {
	let id = JSON.parse(options.body).id;
	for(var i = 0; i < memberList.length; i++) {
		if(memberList[i].id == id) {
			return memberList[i].content
		}
	}
})